module.exports = __webpack_public_path__ + "static/img/fuli_1.6b82a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_10_23/fuli_1.png
// module id = LWSG
// module chunks = 1